(function () {
'use strict';
var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function behavior() { return REDUCED ? 'auto' : 'smooth'; }
function slice(list) { return Array.prototype.slice.call(list); }
function readVariants(root) {
var el = root.querySelector('[data-ftt-variants]');
if (!el) return [];
try { return JSON.parse(el.textContent); } catch (err) { return []; }
}
function createFormController(form, variants) {
var idInput = form.querySelector('[data-ftt-id]');
var groups = slice(form.querySelectorAll('[data-ftt-option-group]'));
var locked = slice(form.querySelectorAll('[data-ftt-locked-option]'));
var atcBtn = form.querySelector('[data-ftt-atc]');
var dynamicWrap = form.querySelector('[data-ftt-dynamic]');
var ctrl = { form: form, onChange: null };
function selectedOptions() {
var opts = {};
locked.forEach(function (el) {
opts[el.getAttribute('data-ftt-position')] = el.getAttribute('data-ftt-value');
});
groups.forEach(function (g) {
var checked = g.querySelector('[data-ftt-option-input]:checked');
if (checked) opts[g.getAttribute('data-ftt-position')] = checked.value;
});
return opts;
}
function findVariant() {
var opts = selectedOptions();
if (Object.keys(opts).length < groups.length + locked.length) return null;
for (var i = 0; i < variants.length; i++) {
var v = variants[i];
if ((!opts['1'] || v.option1 === opts['1']) &&
(!opts['2'] || v.option2 === opts['2']) &&
(!opts['3'] || v.option3 === opts['3'])) {
return v;
}
}
return null;
}
function clearError() {
form.classList.remove('ftt-form--error');
slice(form.querySelectorAll('[data-ftt-size-error]')).forEach(function (e) { e.hidden = true; });
}
function update() {
var v = findVariant();
if (!v) return null;
idInput.value = v.id;
idInput.disabled = false;
clearError();
if (dynamicWrap) dynamicWrap.hidden = !v.available;
if (atcBtn) {
atcBtn.disabled = !v.available;
if (!v.available) atcBtn.textContent = 'SOLD OUT';
}
return v;
}
form.addEventListener('change', function (e) {
if (!e.target || !e.target.hasAttribute || !e.target.hasAttribute('data-ftt-option-input')) return;
update();
if (ctrl.onChange) ctrl.onChange(e.target.getAttribute('data-ftt-position'), e.target.value);
});
ctrl.variantId = function () { var v = findVariant(); return v ? v.id : null; };
ctrl.selectedLabel = function () {
var parts = [];
groups.forEach(function (g) {
var c = g.querySelector('[data-ftt-option-input]:checked');
if (c) parts.push(c.value);
});
return parts.join(' / ');
};
ctrl.setOption = function (position, value) {
var inputs = slice(form.querySelectorAll('[data-ftt-option-input][data-ftt-position="' + position + '"]'));
for (var i = 0; i < inputs.length; i++) {
if (inputs[i].value === value && !inputs[i].checked) {
inputs[i].checked = true;
update();
break;
}
}
};
ctrl.showError = function () {
form.classList.add('ftt-form--error');
slice(form.querySelectorAll('[data-ftt-size-error]')).forEach(function (e) { e.hidden = false; });
var g = groups[0];
if (g) {
g.scrollIntoView({ behavior: behavior(), block: 'center' });
var first = g.querySelector('[data-ftt-option-input]');
if (first) first.focus({ preventScroll: true });
}
};
return ctrl;
}
function initGallery(root) {
var gallery = root.querySelector('[data-ftt-gallery]');
if (!gallery) return;
var track = gallery.querySelector('[data-ftt-track]');
var slides = slice(gallery.querySelectorAll('[data-ftt-slide]'));
var dots = slice(gallery.querySelectorAll('[data-ftt-dot]'));
if (!track || slides.length < 2) return;
var current = 0;
var desktop = window.matchMedia('(min-width: 990px)');
function setActive(i) {
if (i === current) return;
current = i;
dots.forEach(function (d, di) { d.setAttribute('aria-current', di === i ? 'true' : 'false'); });
slides.forEach(function (s, si) {
var video = s.querySelector('video');
if (!video || video.hasAttribute('data-ftt-auto')) return;
if (si !== i && !video.paused) video.pause();
});
}
var ticking = false;
track.addEventListener('scroll', function () {
if (desktop.matches || ticking) return;
ticking = true;
window.requestAnimationFrame(function () {
ticking = false;
var mid = track.scrollLeft + track.clientWidth / 2;
for (var i = 0; i < slides.length; i++) {
if (mid >= slides[i].offsetLeft && mid < slides[i].offsetLeft + slides[i].offsetWidth) {
setActive(i);
break;
}
}
});
}, { passive: true });
dots.forEach(function (d) {
d.addEventListener('click', function () {
var i = parseInt(d.getAttribute('data-index'), 10);
track.scrollTo({ left: slides[i].offsetLeft, behavior: behavior() });
});
});
track.addEventListener('keydown', function (e) {
if (desktop.matches) return;
var target = null;
if (e.key === 'ArrowRight') target = Math.min(slides.length - 1, current + 1);
if (e.key === 'ArrowLeft') target = Math.max(0, current - 1);
if (target === null) return;
e.preventDefault();
track.scrollTo({ left: slides[target].offsetLeft, behavior: behavior() });
});
}
function initReveal(root) {
slice(root.querySelectorAll('[data-ftt-reveal]')).forEach(function (rev) {
var btn = rev.querySelector('[data-ftt-reveal-btn]');
if (!btn) return;
var label = btn.querySelector('[data-ftt-reveal-label]');
var onText = btn.getAttribute('data-label-on') || 'BACK TO DAYLIGHT';
var offText = btn.getAttribute('data-label-off') || 'HIT IT WITH THE LIGHT';
function setLit(lit) {
rev.classList.toggle('is-lit', lit);
btn.setAttribute('aria-pressed', lit ? 'true' : 'false');
if (label) label.textContent = lit ? onText : offText;
}
btn.addEventListener('click', function () {
setLit(!rev.classList.contains('is-lit'));
});
if (REDUCED || !('IntersectionObserver' in window)) return;
if (rev.getAttribute('data-ftt-autoplay') === 'false') return;
var played = false;
var io = new IntersectionObserver(function (entries) {
if (played || !entries[0].isIntersecting) return;
played = true;
io.disconnect();
window.setTimeout(function () { setLit(true); }, 450);
window.setTimeout(function () { setLit(false); }, 2150);
}, { threshold: 0.55 });
io.observe(rev);
});
}
function initAutoplayVideos(root) {
slice(root.querySelectorAll('.ftt-reveal__video video, .ftt-gallery__media video')).forEach(function (v) {
v.setAttribute('data-ftt-auto', '');
v.muted = true;
v.defaultMuted = true;
v.loop = true;
v.setAttribute('muted', '');
v.setAttribute('playsinline', '');
v.setAttribute('webkit-playsinline', '');
v.removeAttribute('controls');
v.controls = false;
if (REDUCED) { v.controls = true; return; }
function tryPlay() {
var p = v.play();
if (p && p.catch) p.catch(function () { v.controls = true; });
}
if ('IntersectionObserver' in window) {
new IntersectionObserver(function (entries) {
if (entries[0].isIntersecting) tryPlay();
else if (!v.paused) v.pause();
}, { threshold: 0.4 }).observe(v);
} else {
tryPlay();
}
function onFirstTouch() {
if (v.paused) tryPlay();
document.removeEventListener('touchstart', onFirstTouch);
document.removeEventListener('click', onFirstTouch);
}
document.addEventListener('touchstart', onFirstTouch, { passive: true });
document.addEventListener('click', onFirstTouch);
});
}
function initLightbox(root) {
var box = root.querySelector('[data-ftt-lightbox]');
if (!box || typeof box.showModal !== 'function') return;
var img = box.querySelector('[data-ftt-lightbox-img]');
var closeBtn = box.querySelector('[data-ftt-lightbox-close]');
slice(root.querySelectorAll('[data-ftt-zoom]')).forEach(function (trigger) {
trigger.addEventListener('click', function () {
var src = trigger.getAttribute('data-zoom-src');
var alt = trigger.getAttribute('data-zoom-alt') || '';
if (!src) return;
img.setAttribute('src', src);
img.setAttribute('alt', alt);
box.showModal();
});
});
if (closeBtn) closeBtn.addEventListener('click', function () { box.close(); });
box.addEventListener('click', function (e) {
if (e.target === box || e.target === img.parentNode) box.close();
});
}
function initStickyBar(root, controller) {
var bar = root.querySelector('[data-ftt-stickybar]');
if (!bar || !controller || !('IntersectionObserver' in window)) return;
var atc = controller.form.querySelector('[data-ftt-atc]');
if (!atc) return;
var io = new IntersectionObserver(function (entries) {
var entry = entries[0];
var passed = entry.boundingClientRect.top < 0;
bar.hidden = entry.isIntersecting || !passed;
}, { threshold: 0 });
io.observe(atc);
var label = bar.querySelector('[data-ftt-sticky-label]');
var base = label ? label.textContent.trim() : '';
controller.form.addEventListener('change', function () {
if (!label) return;
var sel = controller.selectedLabel();
label.textContent = sel ? base + ' — ' + sel : base;
});
}
function initSizeGuide(root) {
var dialog = root.querySelector('[data-ftt-size-dialog]');
if (!dialog) return;
var supported = typeof dialog.showModal === 'function';
var closeBtn = dialog.querySelector('[data-ftt-dialog-close]');
slice(root.querySelectorAll('[data-ftt-size-guide-open]')).forEach(function (btn) {
btn.addEventListener('click', function () {
if (supported) dialog.showModal();
else dialog.setAttribute('open', '');
});
});
if (closeBtn) {
closeBtn.addEventListener('click', function () {
if (supported) dialog.close();
else dialog.removeAttribute('open');
});
}
dialog.addEventListener('click', function (e) {
if (e.target === dialog && supported) dialog.close();
});
}
function initUnitToggle(root) {
slice(root.querySelectorAll('[data-ftt-unit]')).forEach(function (btn) {
btn.addEventListener('click', function () { setUnit(root, btn.getAttribute('data-ftt-unit')); });
});
}
function setUnit(root, unit) {
slice(root.querySelectorAll('[data-ftt-unit]')).forEach(function (b) {
b.setAttribute('aria-pressed', b.getAttribute('data-ftt-unit') === unit ? 'true' : 'false');
});
slice(root.querySelectorAll('[data-ftt-cm]')).forEach(function (cell) {
var raw = (cell.getAttribute('data-ftt-cm') || '').trim();
if (!/^\d+(\.\d+)?$/.test(raw)) return;
var cm = parseFloat(raw);
cell.textContent = unit === 'in' ? String(Math.round((cm / 2.54) * 10) / 10) : raw;
});
slice(root.querySelectorAll('[data-ftt-unit-note]')).forEach(function (n) {
n.textContent = unit === 'in' ? 'All measurements in inches.' : 'All measurements in centimetres.';
});
}
function initSection(root) {
if (!root || root.getAttribute('data-ftt-init') === 'true') return;
root.setAttribute('data-ftt-init', 'true');
var variants = readVariants(root);
var forms = slice(root.querySelectorAll('form[data-ftt-form]'));
var controllers = forms.map(function (f) { return createFormController(f, variants); });
controllers.forEach(function (c) {
c.onChange = function (position, value) {
controllers.forEach(function (other) { if (other !== c) other.setOption(position, value); });
};
});
document.addEventListener('submit', function (e) {
var idx = forms.indexOf(e.target);
if (idx === -1) return;
if (!controllers[idx].variantId()) {
e.preventDefault();
e.stopPropagation();
controllers[idx].showError();
}
}, true);
initGallery(root);
initReveal(root);
initAutoplayVideos(root);
initLightbox(root);
initStickyBar(root, controllers[0]);
initSizeGuide(root);
initUnitToggle(root);
}
function initAll() {
slice(document.querySelectorAll('[data-section-type="ftt-reflective-tee"]')).forEach(initSection);
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', initAll);
} else {
initAll();
}
document.addEventListener('shopify:section:load', function (e) {
var el = e.target && e.target.querySelector('[data-section-type="ftt-reflective-tee"]');
if (el) initSection(el);
});
})();
